<template>
  <div class="addMoreCollection">
    <div class="addMoreCollection__header">
      <div class="addMoreCollection__header__left">
        <div class="addMoreCollection__header__left__top" @click="backToCollectionEditor">
          <div class="addMoreCollection__header__left__top__back">
            <img src="/img/icons/ic-arrow-left.svg" alt="">
            <p>Back to collection group editor</p>
          </div>
        </div>
        <div class="addMoreCollection__header__left__title">
          <h1 class="medium-title">Add Collection</h1>
        </div>
      </div>
    </div>
    <div class="addMoreCollection__filter">
      <div class="addMoreCollection__filter__left">
        <adx-dropdown-list class="" @selected="selectedVisibility" :list="list" labelButton="All visibility" />
      </div>
      <div class="addMoreCollection__filter__right">
      </div>
    </div>
    <div class="addMoreCollection__content">
      <div class="addMoreCollection__content__left">
        <div class="addMoreCollection__content__left__header">
          <div class="addMoreCollection__content__left__header__search">
            <div class="addMoreCollection__content__left__header__search__input">
              <i class="adx-ic_search"></i>
              <input type="text" class="subhead" placeholder="Search" v-model="searchBoxValue">
            </div>
          </div>
        </div>
        <div v-if="searchError" class="addMoreCollection__content__left__header__error">
          <div class="addMoreCollection__content__left__header__error__top">
            <span>We didn't find any match for : </span>
            <span class="search">"{{searchBoxValue}}"</span>
          </div>
          <div class="addMoreCollection__content__left__header__error__bottom">
            <span>Maybe you want to check other listing : </span>
          </div>
        </div>
        <div class="addMoreCollection__content__left__listing">
          <adx-item-list :items="items" :loading="isLoading" :headers="headers" @reloadData="initalLoad">
          <!-- <adx-infinite-loading slot="infiniteLoading" @infinite="loadData($event)" :isFirstLoad="false" :distance="1" ref="InfiniteLoadingRefs">
              <span slot="no-more">
              </span>
              <span slot="no-results">
              </span>
              <span slot="spinner">
              </span>
          </adx-infinite-loading> -->
            <template slot="loading" v-if="items.length > 0">
              <template v-if="!isLoading">
                <div v-if="next" class="addMoreCollection__content__left__listing__paging" @click.stop="loadData">
                  <span class="addMoreCollection__content__left__listing__paging__load">Show more</span>
                </div>
                <div v-else class="addMoreCollection__content__left__listing__paging">
                  <span class="addMoreCollection__content__left__listing__paging__empty"> There is no more data </span>
                </div>
              </template>
              <template v-else>
                <adx-loading slot="loading" />
              </template>
            </template>
          </adx-item-list>
        </div>
      </div>
      <div class="addMoreCollection__content__right">
        
      </div>
    </div>
  </div>
</template>

<script>
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListAddMore from '@/views/Collection/AddMoreCollectionGroup/ListAddmore'
import QuickFilter from '@/components/QuickFilter'
import BreadCrumb from '@/components/Breadcrumb'
import Modal from '@/components/Modal'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { deviceParams } from '@/api/params'
import { fromKeys } from '@/lib/transformer'
import types from '@/lib/types'
import InfiniteLoading from 'vue-infinite-loading'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-addmore-collectioneditor',
  components: {
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'adx-item-list': ListAddMore,
    'adx-quick-filter': QuickFilter,
    'adx-breadcrumb': BreadCrumb,
    'adx-infinite-loading': InfiniteLoading,
    'adx-modal': Modal,
    'adx-loading': Loading,
  },
  data () {
    return {
      count: 0,
      page: 0,
      next: '',
      LocationList: [],
      BrandList: [],
      SortList: [],
      items: [],
      isLoading: false,
      isInit: true,
      searchBoxValue: '',
      searchError: false,
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      isTypeExpand: [],
      selectedVisibilityValue: '',
      list: [
        {
          'id': 0,
          'label': 'All visibility',
          'value': '',
        },
        {
          'id': 1,
          'label': 'Public',
          'value': 'public'
        },
        {
          'id': 2,
          'label': 'Private',
          'value': 'private'
        },
      ],
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        visibility: this.selectedVisibilityValue || undefined,
        search: this.searchBoxValue || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(function () {
        this.initalLoad()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    this.initalLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initalLoad(isInit = null) {
      (async () => {
        this.$data.isLoading = true
        const id = this.$route.params.id
        const params = {
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.collectionGroupUnselected(id), { params, needToken: true })
        this.next = data.next
        this.items = data.results
        this.page = 2
        this.$data.isLoading = false
      })();
    },
    async loadData($state) {
      if (this.next) {
        this.isLoading = true
        const id = this.$route.params.id
        let params = {
          page: this.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.collectionGroupUnselected(id), { needToken: true, params: params })
        if (data.results) {
          // this.items = this.items.concat(data.results)
          // this.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
          this.$data.items = this.$data.items.concat(data.results)
          this.$data.count = data.count
          this.$data.next = data.next
        } else {
          // $state.complete()
        }
        this.page += 1
        this.isLoading = false
      }
    },
    backToCollectionEditor() {
      this.$router.push({name: 'collectiongroupeditor', params: { id: this.$route.params.id }})
    },
    selectedVisibility(item){
      this.selectedVisibilityValue = item.value
      this.$nextTick(function () {
        this.initalLoad()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>